import React, { Component } from 'react'
import { withFirebase } from '../../config'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Confirm, Popup } from 'semantic-ui-react'
import { Redirect, Route } from 'react-router-dom'
/*Redux */
import 'firebase/firestore'
import 'firebase/auth'
import firebase from 'firebase/app'
import { connect } from 'react-redux'
import propTypes from 'prop-types'
/* Components */
import GetAllSeries from './GetAllSeries';
import AddSeries from './AddSeries';
import UpdateSeries from './UpdateSeries';
import ViewSeries from './ViewSeries';
import GetAllSeriesList from './GetAllSeriesList';
/* Actions */
import { getUserData } from '../../Actions/MobilePaymentProfileAction';
/* Routes */
import {ADMIN_LAND_PAGE, SIGN_IN, ALL_SERIES, ADD_SERIES,
        UPDATE_SERIES, VIEW_SERIES, GET_SERIES_LIST } from '../../routes';
class SeriesAuth extends Component {

  constructor(props) {
      super(props);
      if (firebase.auth().currentUser) {
          firebase.auth().currentUser.getIdToken().then((token) => {
              this.props.getUserData(token);
          })
      }
  }

  componentDidMount() {
      const { userPaymentProfile } = this.props;
      const { auth } = this.props;
      if (!auth.uid) {
          return <Redirect to={SIGN_IN}></Redirect>
      }
  }

  render() {
    const { userPaymentProfile } = this.props;

    if(userPaymentProfile.user_role.role === "Analyst"){
      return <Redirect to={ADMIN_LAND_PAGE}></Redirect>
    }
    return (
      <span>
        {/* adding Series Routers */}
        <Route path={ALL_SERIES} component={GetAllSeries} />
        <Route path={ADD_SERIES} component={AddSeries} />
        <Route path={UPDATE_SERIES} component={UpdateSeries} />
        <Route path={VIEW_SERIES} component={ViewSeries} />
        <Route path={GET_SERIES_LIST} component={GetAllSeriesList} />
      </span>
    )
  }
}

const mapStateToProps = state => ({
    auth: state.firebase.auth,
    userPaymentProfile: state.userPaymentProfile.item,
})

export default withFirebase
(connect
    (mapStateToProps,
        {getUserData}
    )(SeriesAuth)
);
